/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_taskAcceptor",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_mintReward",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_matchmakingBps",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "_genesisMint",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "AcceptedTaskIdsNotSorted",
        type: "error",
    },
    {
        inputs: [],
        name: "ApprovalCallerNotOwnerNorApproved",
        type: "error",
    },
    {
        inputs: [],
        name: "ApprovalQueryForNonexistentToken",
        type: "error",
    },
    {
        inputs: [],
        name: "BalanceQueryForZeroAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "CannotSelfBreed",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidQueryRange",
        type: "error",
    },
    {
        inputs: [],
        name: "MintERC2309QuantityExceedsLimit",
        type: "error",
    },
    {
        inputs: [],
        name: "MintToZeroAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "MintZeroQuantity",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "TokenId",
                name: "id",
                type: "uint256",
            },
        ],
        name: "NoSuchToken",
        type: "error",
    },
    {
        inputs: [],
        name: "NotListed",
        type: "error",
    },
    {
        inputs: [],
        name: "NotOwner",
        type: "error",
    },
    {
        inputs: [],
        name: "NotTaskAcceptor",
        type: "error",
    },
    {
        inputs: [],
        name: "NotTaskHub",
        type: "error",
    },
    {
        inputs: [],
        name: "OwnerQueryForNonexistentToken",
        type: "error",
    },
    {
        inputs: [],
        name: "OwnershipNotInitializedForExtraData",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "PaymentRequired",
        type: "error",
    },
    {
        inputs: [],
        name: "SubmisionTaskIdsNotSorted",
        type: "error",
    },
    {
        inputs: [],
        name: "TransferCallerNotOwnerNorApproved",
        type: "error",
    },
    {
        inputs: [],
        name: "TransferFromIncorrectOwner",
        type: "error",
    },
    {
        inputs: [],
        name: "TransferToNonERC721ReceiverImplementer",
        type: "error",
    },
    {
        inputs: [],
        name: "TransferToZeroAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "URIQueryForNonexistentToken",
        type: "error",
    },
    {
        inputs: [],
        name: "UnknownQuantifier",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "fromTokenId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "toTokenId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
        ],
        name: "ConsecutiveTransfer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "TokenId",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Delisted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "TokenId",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Incubated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "TokenId",
                name: "tokenId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "fee",
                type: "uint256",
            },
        ],
        name: "Listed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "matchmakingBps",
                type: "uint256",
            },
        ],
        name: "MatchmakingFeeChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "mintReward",
                type: "uint256",
            },
        ],
        name: "MintRewardChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "TokenId",
                name: "left",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "TokenId",
                name: "right",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "TokenId",
                name: "child",
                type: "uint256",
            },
        ],
        name: "Spawned",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "to",
                type: "address",
            },
        ],
        name: "TaskAcceptorChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "to",
                type: "address",
            },
        ],
        name: "TaskHubChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "_taskIds",
                type: "uint256[]",
            },
            {
                internalType: "bytes",
                name: "_proof",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_report",
                type: "bytes",
            },
        ],
        name: "acceptTaskResults",
        outputs: [
            {
                components: [
                    {
                        internalType: "enum ITaskAcceptorV1.Quantifier",
                        name: "quantifier",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256[]",
                        name: "taskIds",
                        type: "uint256[]",
                    },
                ],
                internalType: "struct ITaskAcceptorV1.TaskIdSelector",
                name: "sel",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "TokenId",
                name: "_left",
                type: "uint256",
            },
            {
                internalType: "TokenId",
                name: "_right",
                type: "uint256",
            },
        ],
        name: "breed",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "TokenId",
                name: "_tokenId",
                type: "uint256",
            },
        ],
        name: "delist",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "earnings",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "explicitOwnershipOf",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "addr",
                        type: "address",
                    },
                    {
                        internalType: "uint64",
                        name: "startTimestamp",
                        type: "uint64",
                    },
                    {
                        internalType: "bool",
                        name: "burned",
                        type: "bool",
                    },
                    {
                        internalType: "uint24",
                        name: "extraData",
                        type: "uint24",
                    },
                ],
                internalType: "struct IERC721A.TokenOwnership",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "tokenIds",
                type: "uint256[]",
            },
        ],
        name: "explicitOwnershipsOf",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "addr",
                        type: "address",
                    },
                    {
                        internalType: "uint64",
                        name: "startTimestamp",
                        type: "uint64",
                    },
                    {
                        internalType: "bool",
                        name: "burned",
                        type: "bool",
                    },
                    {
                        internalType: "uint24",
                        name: "extraData",
                        type: "uint24",
                    },
                ],
                internalType: "struct IERC721A.TokenOwnership[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "breeder",
                type: "address",
            },
            {
                internalType: "TokenId",
                name: "_left",
                type: "uint256",
            },
            {
                internalType: "TokenId",
                name: "_right",
                type: "uint256",
            },
        ],
        name: "getBreedingFee",
        outputs: [
            {
                internalType: "uint256",
                name: "fee",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_offset",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_count",
                type: "uint256",
            },
        ],
        name: "getStuds",
        outputs: [
            {
                components: [
                    {
                        internalType: "TokenId",
                        name: "tokenId",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "fee",
                        type: "uint256",
                    },
                ],
                internalType: "struct NFTrout.Stud[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "TokenId",
                name: "_tokenId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_fee",
                type: "uint256",
            },
        ],
        name: "list",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "matchmakingBps",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "mint",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "mintReward",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "TokenId",
                name: "",
                type: "uint256",
            },
        ],
        name: "parents",
        outputs: [
            {
                internalType: "TokenId",
                name: "left",
                type: "uint256",
            },
            {
                internalType: "TokenId",
                name: "right",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_matchBps",
                type: "uint256",
            },
        ],
        name: "setMatchmakingFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_mintReward",
                type: "uint256",
            },
        ],
        name: "setMintReward",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_newTaskAcceptor",
                type: "address",
            },
        ],
        name: "setTaskAcceptor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_newTaskHub",
                type: "address",
            },
        ],
        name: "setTaskHub",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "taskAcceptor",
        outputs: [
            {
                internalType: "contract ITaskAcceptorV1",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "taskHub",
        outputs: [
            {
                internalType: "contract ITaskHubV1",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "tokensOfOwner",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "start",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "stop",
                type: "uint256",
            },
        ],
        name: "tokensOfOwnerIn",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class NFTrout__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(_taskAcceptor, _mintReward, _matchmakingBps, _genesisMint, overrides) {
        return super.getDeployTransaction(_taskAcceptor, _mintReward, _matchmakingBps, _genesisMint, overrides || {});
    }
    deploy(_taskAcceptor, _mintReward, _matchmakingBps, _genesisMint, overrides) {
        return super.deploy(_taskAcceptor, _mintReward, _matchmakingBps, _genesisMint, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
